import { FieldType } from 'modules/domains';

export const isNumberFieldType = (type?: FieldType): type is FieldType.INTEGER | FieldType.FLOAT =>
  type === FieldType.INTEGER || type === FieldType.FLOAT;
